"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabRequisitionsContext = void 0;
const react_1 = require("react");
exports.LabRequisitionsContext = (0, react_1.createContext)({});
